export default "__VITE_ASSET__yfOVsqEo__"